import { useMutation } from '@apollo/client'
import {
  REFRESH_ELIGIBLE_PERSON_MAGIC_LINK,
  SCRUB_ELIGIBLE_PERSON,
  UPDATE_ELIGIBLE_PERSON,
} from '../mutations'
import {
  RefreshEligiblePersonToken,
  RefreshEligiblePersonTokenVariables,
} from '../mutations/types/RefreshEligiblePersonToken'
import { GET_ELIGIBLE_PERSON } from '../queries'

type TEligiblePersonProps = {
  id: string
  terminationDate?: string
}

const useEligiblePersonMutation = (eligiblePersonId: string) => {
  const [mutate, { loading, error }] = useMutation(UPDATE_ELIGIBLE_PERSON, {
    refetchQueries: [{ query: GET_ELIGIBLE_PERSON, variables: { id: eligiblePersonId } }],
  })

  // sending an empty string for terminationDate is the way to "unset" an existing terminationDate
  const updateEligiblePerson = ({ id, terminationDate }: TEligiblePersonProps) => {
    return mutate({
      variables: { id, updateData: { terminationDate } },
    })
  }

  return { updateEligiblePerson, error, loading }
}

const useEligiblePersonScrub = ({
  eligiblePersonId,
  partnerHashId,
}: {
  eligiblePersonId: string
  partnerHashId: string
}) => {
  const [mutate, { loading, error }] = useMutation(SCRUB_ELIGIBLE_PERSON, {
    refetchQueries: [
      {
        query: GET_ELIGIBLE_PERSON,
        variables: { id: eligiblePersonId, partnerHashId },
      },
    ],
  })

  const scrubEligiblePerson = () => {
    return mutate({
      variables: {
        eligiblePersonId,
      },
    })
  }

  return { scrubEligiblePerson, error, loading }
}

const useEligiblePersonMagicLink = ({
  eligiblePersonId,
}: {
  eligiblePersonId: string
}) => {
  const [mutate, { loading, error }] = useMutation<
    RefreshEligiblePersonToken,
    RefreshEligiblePersonTokenVariables
  >(REFRESH_ELIGIBLE_PERSON_MAGIC_LINK, {
    variables: { eligiblePersonId },
  })

  const refreshMagicLink = () => mutate()

  return { refreshMagicLink, loading, error }
}

export { useEligiblePersonMagicLink, useEligiblePersonMutation, useEligiblePersonScrub }
